class AccessoriesBundle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.accessories-bundle__button');
    this.init();
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick.bind(this));
    }
  }

  handleButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const normalizeVariantId = (raw) => {
      if (raw == null) return null;
      const str = String(raw).trim();
      if (!str) return null;
      const gidMatch = str.match(/ProductVariant\/(\d+)/);
      if (gidMatch && gidMatch[1]) return gidMatch[1];
      const digits = str.match(/\d+/g);
      if (!digits) return str;
      return digits.join('');
    };

    const buildMainItemFromForm = (productForm) => {
      if (!productForm) return null;
      const idInput = productForm.querySelector('input[name="id"]');
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');

      const id = normalizeVariantId(idInput?.value);
      if (!id) return null;

      const quantityRaw = quantityInput?.value;
      const quantity = Math.max(1, parseInt(quantityRaw || '1', 10) || 1);

      const item = { id, quantity };
      const sellingPlan = normalizeVariantId(sellingPlanInput?.value);
      if (sellingPlan) item.selling_plan = sellingPlan;
      return item;
    };
    
    // Get variant IDs from data attributes
    const travelCaseId = normalizeVariantId(button.dataset.travelCaseId);
    const brushesId = normalizeVariantId(button.dataset.brushesId);
    
    // Get main product form data - this includes the currently selected variant ID
    const mainProductForm = document.querySelector('.product__info-container .main-product-form');
    const mainItem = buildMainItemFromForm(mainProductForm);
    
    // Build items array
    const items = [];
    
    // Add main product with form data (includes properties, quantity, etc.)
    if (mainItem) items.push(mainItem);
    
    // Add travel case if selected
    if (travelCaseId) {
      items.push({
        id: travelCaseId,
        quantity: 1
      });
    }
    
    // Add brushes if selected
    if (brushesId) {
      items.push({
        id: brushesId,
        quantity: 1
      });
    }
    
    // Add active makeup options if any are selected
    const activeVariants = document.querySelectorAll(".makeup-option .makeup-option-image.active");
    if (activeVariants && activeVariants.length > 0) {
      activeVariants.forEach(variant => {
        const variantId = normalizeVariantId(variant.dataset.id);
        if (variantId) {
          items.push({
            id: variantId,
            quantity: 1
          });
        }
      });
    }
    
    if (items.length === 0) {
      return;
    }
    
    // Show loading state
    this.toggleButtonLoading(true);
    
    // Prepare request body
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    
    const addData = {
      items: items,
      sections: sectionsToBundle,
      sections_url: window.location.pathname
    };
    
    // Add all items to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(addData)
    })
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          this.showErrorMessage(parsedState.description);
          return;
        }
        
        const cartJson = await (
          await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })
        ).json();
        cartJson['sections'] = parsedState['sections'];
        
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            detail: {
              product: parsedState,
            },
          })
        );
        
        // Show cart drawer if available
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement) {
          cartDrawerElement.show(button);
        }
      })
      .catch((error) => {
        console.error('Error adding items to cart:', error);
        this.showErrorMessage('An error occurred while adding items to cart.');
      })
      .finally(() => {
        this.toggleButtonLoading(false);
      });
  }

  toggleButtonLoading(isLoading) {
    if (!this.button) return;
    
    if (isLoading) {
      this.button.classList.add('btn--loading');
      this.button.setAttribute('aria-disabled', 'true');
      this.button.disabled = true;
    } else {
      this.button.classList.remove('btn--loading');
      this.button.removeAttribute('aria-disabled');
      this.button.disabled = false;
    }
  }

  showErrorMessage(message) {
    // You can customize error display here
    console.error('Cart error:', message);
    // Optionally show a notification or error message to the user
  }
}

customElements.define('accessories-bundle', AccessoriesBundle);

